import React from 'react';
import cn from 'classnames';
import { FormGroup, Callout } from '@blueprintjs/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import FormIcons from '../../../assets/form-icons/line';
import styles from './styles.module.css';

import { Droppable, Draggable } from 'react-beautiful-dnd';

const DraggableHandle = () => (
  <div className={styles.dragHandle}>
    <FontAwesomeIcon icon="grip-vertical" />
  </div>
);

const SortableField = ({
  index,
  field,
  dragActive,
  selectedFieldKey,
  onFieldSelected,
  onFieldEdit,
}) => {
  let Icon = FormIcons[field.inputType];
  if (!Icon) {
    Icon = FormIcons['helptext'];
  }
  return (
    <Draggable draggableId={field.key} index={index}>
      {(provided, snapshot) => {
        return (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            className={cn(styles.fieldContainer, {
              [styles.enabledContainer]: !dragActive,
              [styles.selectedContainer]: selectedFieldKey === field.key,
              [styles.fieldDeleted]: field.deleted,
              [styles.fieldDisabled]: !field.inUse,
            })}
            onClick={() => onFieldSelected(field.key)}
            onDoubleClick={() => onFieldEdit(field.key)}
          >
            <div
              className={cn(styles.fieldContent, {
                [styles.fieldContentDisabled]: !field.inUse,
              })}
            >
              <div className={styles.fieldImageContainer}>
                <Icon className={styles.fieldImage} />
              </div>
              {field.label}
            </div>
            <DraggableHandle />
          </div>
        );
      }}
    </Draggable>
  );
};

const SortableFieldList = ({ sortableFields, ...props }) => {
  return (
    <Droppable droppableId="FIELDS">
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          style={{
            minHeight: '300px',
          }}
        >
          {sortableFields.map((field, idx) => (
            <SortableField
              key={field.key}
              index={idx}
              field={field}
              {...props}
            />
          ))}
        </div>
      )}
    </Droppable>
  );
};

export const FieldTab = ({
  fields,
  onFieldEdit,
  onFieldSelected,
  selectedFieldKey,
}) => {
  return (
    <FormGroup>
      {fields && fields.length === 0 && (
        <Callout>
          This section currently has no fields. Add them from the Field Library
        </Callout>
      )}
      {fields && (
        <SortableFieldList
          sortableFields={fields}
          onFieldSelected={onFieldSelected}
          onFieldEdit={onFieldEdit}
          selectedFieldKey={selectedFieldKey}
        />
      )}
    </FormGroup>
  );
};
